import api from './api'

/**
 * 获取产品列表
 * @param {Object} params 查询参数
 * @param {string} params.model 产品型号（模糊查询，可选）
 * @param {string} params.brand 品牌（模糊查询，可选）
 * @param {string} params.chip_spec 芯片规格（模糊查询，可选）
 * @param {string} params.tag_code 标签编码（精确查询，可选；传 "-" 查询空标签）
 * @param {number} params.skip 跳过记录数（可选）
 * @param {number} params.limit 每页条数（可选）
 * @returns {Promise} 包含products、total、page、size的对象
 */
export async function getProducts(params) {
  const res = await api.get('/api/v1/products', { params })
  return res.data
}

/**
 * 获取产品详情
 * @param {string|number} id 产品ID
 * @returns {Promise}
 */
export async function getProduct(id) {
  const res = await api.get(`/api/v1/products/${id}`)
  return res.data
}

/**
 * 创建产品
 * @param {Object} productData 产品数据
 * @param {string} productData.model 产品型号
 * @param {string} productData.brand 品牌
 * @param {string} productData.tag_code 标签编码
 * @param {string} productData.chip_spec 芯片规格
 * @param {string} productData.memory_spec 内存规格
 * @param {string} productData.synonyms 别名
 * @returns {Promise}
 */
export async function createProduct(productData) {
  const res = await api.post('/api/v1/products/create', productData)
  return res.data
}

/**
 * 更新产品
 * @param {string|number} id 产品ID
 * @param {Object} productData 产品数据
 * @param {string} productData.model 产品型号
 * @param {string} productData.brand 品牌
 * @param {string} productData.tag_code 标签编码
 * @param {string} productData.chip_spec 芯片规格
 * @param {string} productData.memory_spec 内存规格
 * @param {string} productData.synonyms 别名
 * @returns {Promise}
 */
export async function updateProduct(id, productData) {
  const res = await api.put(`/api/v1/products/update/${id}`, productData)
  return res.data
}

/**
 * 删除产品
 * @param {string|number} id 产品ID
 * @returns {Promise}
 */
export async function deleteProduct(id) {
  const res = await api.delete(`/api/v1/products/delete/${id}`)
  return res.data
}
